import { EpocusBrandLockup } from "$components/epocus-logomark";
import {
  EPOCUS_FONT_FAMILY,
  EPOCUS_TEXT_SECONDARY,
} from "$routes/epocus/_lib/epocus-palette";
import { styled } from "@material-ui/core";
import React from "react";
import { FormattedMessage } from "react-intl";

const Container = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(2),
}));
/**
 * Uses raw HTML elements and injects translations and styled components so that this page may be used at the
 * root of our app, outside of any contexts.
 */

export const LoadingLogo: FC<
  {
    translations?: { loadingTip?: string };
    logomark?: React.ReactNode;
  } & React.HTMLAttributes<HTMLDivElement>
> = ({
  logomark = <EpocusBrandLockup />,
  translations = {
    loadingTip: (
      <FormattedMessage id="loading.tip" defaultMessage="Loading..." />
    ),
  },
  ...restProps
}) => (
  <Container role="progressbar" {...restProps}>
    {logomark}
    <h6
      style={{
        fontFamily: EPOCUS_FONT_FAMILY,
        fontSize: "1rem",
        fontWeight: 400,
        lineHeight: 1.75,
        color: EPOCUS_TEXT_SECONDARY,
        marginBlock: 0,
      }}
    >
      {translations.loadingTip}
    </h6>
  </Container>
);
